import './style.scss'
import { useNavigate, useParams } from "react-router-dom"
import ApiContext from 'src/provider/API/call-service'
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import { IoIosArrowBack, IoIosStar, IoIosStarOutline } from "react-icons/io"
import { AppLink, AppSpan, AppText, Button, Circle, CustomContainer, FlexRow, PageTitle, PageWrapper } from "src/style"
import utility, { moneyFormat } from "src/utils/utility"
import helpers from "src/utils/helpers"
import { useContext, useEffect, useState } from 'react'
import { Product } from 'src/model'
import { IoArrowBackOutline } from 'react-icons/io5'
import { BsShare } from 'react-icons/bs'
import { VscGlobe } from 'react-icons/vsc'
import { ReactComponent as MoneyIcon } from "src/assets/img/money-icon.svg";
import { InstallationConfirmation, IntegrationRequest, ProductSharing } from 'src/popup'

const ProductComments = () => {
    const navigate = useNavigate()
    const { productId } = useParams()
    const {API} = useContext(ApiContext)
    const {decisionBox} = useContext(VisibilityContext)
    const {info: {selectedProduct}} = useContext(AppInfoContext)
    const [product, setProduct] = useState<Product|null>(selectedProduct)
    const [productWebsite, setProductWebsite] = useState('')
    const [reviews, setReviews] = useState<Array<any>>([])
    const [view, setView] = useState('')

    useEffect(() => {
        if (selectedProduct?.id) {
            setProduct(selectedProduct)
            setProductWebsite(selectedProduct?.serviceProvider?.websiteURL || selectedProduct?.websiteUrl)
        }
    }, [selectedProduct])

    useEffect(() => {
        handleFetchReviews()
        getProductById()
    }, [])

    function getProductById () {
        API.getProductById(productId)
    }

    async function handleFetchReviews () {
        const response = await API.getProductReviews({
            pageNumber: 1, 
            pageSize: 1000,
            filter: { productId }
        })

        if (response) setReviews(response.data)
    }

    function handleProductIntegration () {
        setView(product?.integrationStatus || 'ComingSoon')

        if (product?.integrationStatus === 'AvailableAutomatically') {
            decisionBox.show(
                `Are you sure you are ready to install ${product?.name} for your Bank? Click yes to proceed`,
                () => setView('product-installation'),
                decisionBox.hide,
                `Yes`,
                'No'
            )
        }
    }

    return (
        <>
            <PageWrapper>
                {/* <FlexRow 
                    width="auto" sizeUnit="" 
                    gap="1" bottomPadding="2.5"
                    style={{borderBottom: "1px solid #EAECF0"}}
                    onClick={() => navigate(-1)}
                >
                    <AppSpan textSize='2.5' cursor='pointer' bottomMargin='1' >
                        <IoIosArrowBack />
                    </AppSpan>
                    <PageTitle 
                        color='#101828' textSize='3' fontWeight="500"
                    >
                        Comments
                    </PageTitle>
                </FlexRow> */}
                <FlexRow 
                    gap="0.7" bottomMargin="2"
                    onClick={() => navigate(-1)}
                >
                    <IoArrowBackOutline color="#0A756F" fontSize='1.7rem' />
                    <AppText 
                        color="#0A756F" fontWeight="500"
                        cursor="pointer"
                    >
                        Back
                    </AppText>
                </FlexRow>
                <FlexRow justifyContent="space-between" alignItems="flex-start" gap="2.5" wrap='wrap'>
                    <FlexRow 
                        width="auto" sizeUnit="" gap="1.5"
                        alignItems="flex-start"
                    >
                        <Circle 
                            size="7" bgColor='#ffffff' 
                            borderColor='#EAECF0'
                            className='fixed-flex-shape'
                            style={{overflow: 'hidden'}}
                        >
                            <Circle 
                                size='6'
                                style={{overflow: 'hidden'}}
                            >
                                <img 
                                    src={product?.logoUrl} 
                                    className='img-covered' 
                                    style={{objectFit: 'contain'}} 
                                />
                            </Circle>
                        </Circle>
                        <CustomContainer width="auto" sizeUnit="">
                            <PageTitle 
                                color='#101828' textSize='3' fontWeight="500"
                            >
                                {product?.name}
                            </PageTitle>
                            <FlexRow gap="2.5" width="auto" sizeUnit="" wrap="wrap">
                                <FlexRow width="auto" sizeUnit="" gap="0.7">
                                    <VscGlobe color='#3374EF' fontSize='2rem' />
                                    <AppLink
                                        color="#3374EF" textSize="1.6"
                                        fontWeight="500" hoverColor="#ADB5BD"
                                        href={productWebsite} target='_blank'
                                    >
                                        {productWebsite}
                                    </AppLink>
                                </FlexRow>

                                <FlexRow 
                                    gap='1.2'
                                    width="auto" sizeUnit=""
                                >
                                    <FlexRow width='auto' sizeUnit='' gap='0.5'>
                                        {
                                            Array.from(Array(5).keys()).map((item) => {
                                                return (
                                                    <CustomContainer 
                                                        width='auto' sizeUnit=''
                                                        key={item}
                                                    >
                                                        { product?.productStatistic?.averageRating! >= (item + 1) ?
                                                            <IoIosStar fill='#409089' fontSize='1.5rem' />
                                                            : <IoIosStarOutline fill='#344054' fontSize='1.5rem' />
                                                        }
                                                    </CustomContainer>
                                                )
                                            })
                                        }
                                    </FlexRow>
                                    <AppSpan textSize='1'>{(product?.productStatistic?.averageRating || 0)?.toFixed(1)}</AppSpan>
                                </FlexRow>

                                <FlexRow width="auto" sizeUnit="" gap="0.5">
                                    <MoneyIcon className="icon-component" />
                                    { product?.setupFee ?
                                        <AppText textSize='1.6' fontWeight="500" color='#409089'>₦{moneyFormat(product?.setupFee || 0)}</AppText>
                                        : <AppText textSize='1.6' fontWeight="500" color='#0A756F'>No upfront cost</AppText>
                                    }
                                </FlexRow>

                                <FlexRow 
                                    width="auto" sizeUnit="" gap="1"
                                    onClick={() => setView('product-sharing')}
                                >
                                    <BsShare fill="#0085F2" fontSize='1.4rem' />
                                    <AppSpan 
                                        color="#0085F2" textSize='1.6' 
                                        fontWeight="500" cursor="pointer"
                                    >
                                        Share
                                    </AppSpan>
                                </FlexRow>
                            </FlexRow>
                        </CustomContainer>
                    </FlexRow>
                    { !product?.installed &&
                        <Button
                            width={product?.integrationStatus === 'AvailableAutomatically' ? '7.3' :product?.integrationStatus === 'AvailableManually' ? '13' : '18' }
                            height='4' radius='0.8' 
                            hoverColor='#0D968F'
                            hoverBgColor='#fff' 
                            borderColor='#0D968F'
                            onClick={handleProductIntegration}
                        >
                            {product?.integrationStatus === 'AvailableAutomatically' ? 'Install' : product?.integrationStatus === 'AvailableManually' ? 'Request Demo': 'Request Early Access'}
                        </Button>
                    }
                </FlexRow>
                <CustomContainer topMargin="3.5">
                    <FlexRow 
                        justifyContent="space-between" 
                        gap="2" wrap="wrap"
                    >
                        {
                            reviews?.map((item, index) => {
                                const [firstName, lastName] = item.ratedBy?.split(' ')
                                return (
                                    <CustomContainer 
                                        key={index} topMargin="1.5" 
                                        width="48" sizeUnit="%"
                                        className="comment-container"
                                    >
                                        <FlexRow gap="1">
                                            <Circle size="4" bgColor='#0D968F'>
                                                <AppSpan color="#F7F8F9" fontWeight="600">{firstName[0]}{lastName[0]}</AppSpan>
                                            </Circle>
                                            <AppSpan color="#3A3A3A" fontWeight="500">{item.ratedBy}</AppSpan>
                                        </FlexRow>
                                        <FlexRow gap="1" topMargin="1" wrap="wrap">
                                            <FlexRow width="auto" sizeUnit="" gap="0.5">
                                                {
                                                    Array.from(Array(5).keys())?.map((num: number) => {
                                                        return (
                                                            num <= (item?.rating - 1) ?
                                                                <IoIosStar fill='#409089' fontSize='1.4rem' key={num} />
                                                                : <IoIosStarOutline fill='#344054' fontSize='1.4rem' key={num} />
                                                        )
                                                    })
                                                }
                                            </FlexRow>
                                            <AppSpan color="#3A3A3A" textSize="1.2">
                                                {item.dateCreated ? helpers.handleDate(item.dateCreated) : null}
                                            </AppSpan>
                                        </FlexRow>
                                        <AppText topMargin="1">{item.comment?.comment}</AppText>
                                    </CustomContainer>
                                )
                            })
                        }
                    </FlexRow>
                </CustomContainer>
            </PageWrapper>
            { ['AvailableManually', 'ComingSoon'].includes(view) &&
                <IntegrationRequest
                    isDemoRequest={view === 'AvailableManually'}
                    product={product}
                    close={() => setView('')}
                />
            }
            { view === 'product-installation' &&
                <InstallationConfirmation
                    product={product} 
                    getProductUpdate={getProductById}
                    close={() => setView('')}
                />
            }
            { view === 'product-sharing' &&
                <ProductSharing 
                    productId={productId}
                    close={() => setView('')}
                />
            }
        </>
    )
}

export default utility.routeData('product/:productId/comments', 'Product Comments', <ProductComments/>)


const comments = [
    {
        fullName: 'Iyin Laditan',
        rating: 4,
        comment: 'Amazing!!!',
        date: '2024-08-02T16:55:23.957Z'
    },
    {
        fullName: 'Ridwan Kolawole',
        rating: 3,
        comment: 'Amazing!!!',
        date: '2024-08-02T16:55:23.957Z'
    },
    {
        fullName: 'Iyin Laditan',
        rating: 4,
        comment: 'Amazing!!!',
        date: '2024-08-02T16:55:23.957Z'
    },
    {
        fullName: 'Ridwan Kolawole',
        rating: 3,
        comment: 'Amazing!!!',
        date: '2024-08-02T16:55:23.957Z'
    },
    {
        fullName: 'Iyin Laditan',
        rating: 4,
        comment: 'Amazing!!!',
        date: '2024-08-02T16:55:23.957Z'
    },
    {
        fullName: 'Ridwan Kolawole',
        rating: 3,
        comment: 'Amazing!!!',
        date: '2024-08-02T16:55:23.957Z'
    }
]